/**
 * Detail synopsis text component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Detail synopsis text component.
 */
const DetailSynopsisText = styled.div<{ bold?: boolean }>`
  color: ${Colors['text']};
  display: -webkit-box;
  font-family: ${Fonts['light']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
`;

export default DetailSynopsisText;
